import { Route } from "@angular/router";
import { HomeComponent } from "./pages/home/home.component";
import { EvidenciasCorreoGuard } from "./pages/evidencias-correo/evidencias-correo.guard";
import { ConfigAdminGuard } from "./pages/config-admin/config-admin.guard";

const configChildren: Route[] = [
  { path: "", redirectTo: "procedimientos", pathMatch: "full" },
  {
    path: "procedimientos",
    loadComponent: () => import("./pages/config-admin/pages/procedimientos-list.component").then((m) => m.ProcedimientosListComponent),
  },
  {
    path: "procedimientos/:id",
    loadComponent: () => import("./pages/config-admin/pages/procedimiento-detail.component").then((m) => m.ProcedimientoDetailComponent),
  },
  {
    path: "actividades/:id",
    loadComponent: () => import("./pages/config-admin/pages/actividad-detail.component").then((m) => m.ActividadDetailComponent),
  },
  {
    path: "formularios",
    loadComponent: () => import("./pages/config-admin/pages/formularios-list.component").then((m) => m.FormulariosListComponent),
  },
  {
    path: "formularios/:id",
    loadComponent: () => import("./pages/config-admin/pages/formulario-editor.component").then((m) => m.FormularioEditorComponent),
  },
  {
    path: "metadatos",
    loadComponent: () => import("./pages/config-admin/pages/metadatos-list.component").then((m) => m.MetadatosListComponent),
  },
  {
    path: "series",
    loadComponent: () => import("./pages/config-admin/pages/series-list.component").then((m) => m.SeriesListComponent),
  },
  {
    path: "series/:id",
    loadComponent: () => import("./pages/config-admin/pages/serie-detail.component").then((m) => m.SerieDetailComponent),
  },
  {
    path: "tipos-documental",
    loadComponent: () => import("./pages/config-admin/pages/tipos-documental-list.component").then((m) => m.TiposDocumentalListComponent),
  },
  {
    path: "plantillas",
    loadComponent: () => import("./pages/config-admin/pages/plantillas-list.component").then((m) => m.PlantillasListComponent),
  },
  {
    path: "ptd",
    loadComponent: () => import("./pages/config-admin/pages/ptd-list.component").then((m) => m.PtdListComponent),
  },
  {
    path: "ptd/:id",
    loadComponent: () => import("./pages/config-admin/pages/ptd-detail.component").then((m) => m.PtdDetailComponent),
  },
  {
    path: "areas",
    loadComponent: () => import("./pages/config-admin/pages/areas-list.component").then((m) => m.AreasListComponent),
  },
  {
    path: "trabados",
    loadComponent: () => import("./pages/config-admin/pages/procesos-trabados.component").then((m) => m.ProcesosTrabadosComponent),
  },
];

const children: Route[] = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: "control-procesos",
    loadComponent: () => import("./pages/control-procesos/control-procesos.component").then((m) => m.ControlProcesosComponent),
  },
  {
    path: "ejecutar-procesos",
    loadComponent: () => import("./pages/ejecutar-procesos/ejecutar-procesos.component").then((m) => m.EjecutarProcesosComponent),
  },
  {
    path: "ejecutar-procesos/formulario",
    loadComponent: () => import("./pages/ejecutar-procesos/manual/start-process/start-process.component").then((m) => m.StartProcessComponent)
  },
  {
    path: "configuracion",
    canMatch: [ConfigAdminGuard],
    loadComponent: () => import("./pages/config-admin/config-admin.component").then((m) => m.ConfigAdminComponent),
    children: configChildren,
  },
  {
    // Mockup con datos de ejemplo (demo PTA): aún no consulta el back. Solo superusuario
    // mientras no tenga datos reales.
    path: "indicadores",
    canMatch: [ConfigAdminGuard],
    loadComponent: () => import("./pages/indicadores/indicadores-contratacion.component").then((m) => m.IndicadoresContratacionComponent),
  },
  {
    path: "evidencias-correo",
    canMatch: [EvidenciasCorreoGuard],
    loadComponent: () => import("./pages/evidencias-correo/evidencias-correo.component").then((m) => m.EvidenciasCorreoComponent),
  },
];

const routes: Route[] = [
  {
    path: "contrataciones",
    loadComponent: () => import("./contratacion.component").then((m) => m.ContratacionComponent),
    children,
  },
];

export { routes as ContratacionRoutes };
